import client from '../client';

const RENTAL_ESTIMATIONS = {
  createRentalEstimation(params) {
    return client.post('/rentals/estimations', { estimation: params }, { withCredentials: true })
  },
}

export default RENTAL_ESTIMATIONS;
